import Body from './report/Body';
import Layout from './report/Layout';
import { DocumentProps, PageProps } from '@react-pdf/types';

interface ReportProps {
  reportName: string;
  headerData: Record<string, any>;
  reportData: Array<any>;
  reportSettings?: {
    document?: Partial<DocumentProps>;
    page?: Partial<PageProps>;
  };
  signLineTexts?: string[];

}

const Report = ({
                  reportName,
                  headerData,
                  reportData,
                  reportSettings,
                  signLineTexts
                }: ReportProps) => {
  return (
      <Layout
          reportName={reportName}
          reportSettings={reportSettings}
          headerData={headerData}
          signLineTexts={signLineTexts}
      >
        <Body data={reportData} />
      </Layout>
  );
};

export default Report;
